import React from 'react';

import { Link } from '@opendoor/bricks-next';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
  foregroundColor?: string;
}

export const LoginSection: React.FC<LoginSectionProps> = ({
  showLogin,
  onPress,
  foregroundColor,
}) => {
  if (!showLogin) return null;

  return (
    <Link
      href={'#'}
      onPress={onPress}
      fontWeight="$medium"
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      color={(foregroundColor || '$contentPrimary') as React.ComponentProps<typeof Link>['color']}
    >
      Sign in
    </Link>
  );
};
